import { createStyles, Group, Tooltip } from '@mantine/core';
import { KeyboardShortcut } from '@repo/common/components/KeyboardShortcut/KeyboardShortcut';
import { IconButton } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { sideBarStore } from '../SideBar/store';
import { useStyles as useNavbarStyles } from './NavBarBreadcrumbWrapper.styles';

const useStyles = createStyles(
	(theme, { collapsed }: { collapsed: boolean }) => ({
		sidebarToggleButton: {
			marginLeft: -theme.spacing.xs,

			[theme.fn.largerThan('sm')]: {
				display: collapsed ? 'block' : 'none',
			},
		},
	})
);

interface NavBarBreadcrumbWrapperProps {
	children: React.ReactNode;
}

export const NavBarBreadcrumbWrapper = observer(
	({ children }: NavBarBreadcrumbWrapperProps) => {
		const { classes } = useNavbarStyles();
		const { classes: sidebarToggleButtonClasses } = useStyles({
			collapsed: !!sideBarStore.collapsed,
		});

		return (
			<Group spacing={0} noWrap style={{ flex: 1 }}>
				<Tooltip
					label={
						<KeyboardShortcut keys={['[']}>Toggle sidebar</KeyboardShortcut>
					}
				>
					<IconButton
						iconName={
							sideBarStore.collapsed
								? 'layoutSidebar'
								: 'layoutSidebarLeftExpand'
						}
						variant="tertiary"
						onClick={() => sideBarStore.toggle()}
						className={sidebarToggleButtonClasses.sidebarToggleButton}
					/>
				</Tooltip>
				<Group className={classes.breadcrumbWrapper}>{children}</Group>
			</Group>
		);
	}
);
